import { render, staticRenderFns } from "./nowPrice.vue?vue&type=template&id=9d6863ae&scoped=true&"
import script from "./nowPrice.vue?vue&type=script&lang=js&"
export * from "./nowPrice.vue?vue&type=script&lang=js&"
import style0 from "./nowPrice.vue?vue&type=style&index=0&id=9d6863ae&lang=less&scoped=true&"
import style1 from "./nowPrice.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6863ae",
  null
  
)

export default component.exports